import { pluralize } from "./helpers";
export var DOTS = '...';
export var localesMap = ['ru', 'en'];
export var languagesSet = [{
  locale: 'ru',
  translations: {
    titleFound: function titleFound(count) {
      return pluralize(count, ['найден', 'найдено', 'найдено']);
    },
    titleResults: function titleResults(count) {
      return pluralize(count, ['результат', 'результата', 'результатов']);
    },
    titleShow: 'показывать',
    titleBy: 'по'
  }
}, {
  locale: 'en',
  translations: {
    titleFound: 'found',
    titleResults: function titleResults(count) {
      return pluralize(count, ['result', 'results', 'results']);
    },
    titleShow: 'show',
    titleBy: 'by'
  }
}];

/**
 * Набор переводов в зависимости от locale
 */
export var getLanguagesSet = function getLanguagesSet() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ru';
  return languagesSet.find(function (item) {
    return item.locale === locale;
  }) || languagesSet[0];
};